function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import position from 'polished/lib/shorthands/position';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import typography from '../utils/typography';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    isClickable,
    isFocused,
    isSection,
    open,
    showNotification,
    type
  } = _ref;
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  var calcPadding = value => {
    if (isHc) {
      return "calc(".concat(value, " - 1px)");
    }
    return value;
  };
  var iconSize = 36;
  var unreadCircleSize = theme.layout.size2;
  var getStatusColor = isBackground => {
    if (!type) {
      return undefined;
    }
    var value = isBackground ? 'background' : 'default';
    if (type === 'informative') {
      return isBackground ? theme.palette.neutral.background : theme.palette.foreground.light;
    }
    if (type === 'help') {
      return theme.palette.primary[value];
    }
    return theme.palette[type][value];
  };
  return {
    li: _objectSpread(_objectSpread(_objectSpread({
      alignItems: 'flex-start',
      backgroundColor: 'transparent',
      borderColor: theme.palette.stroke.default,
      borderStyle: 'solid',
      borderWidth: '1px 0 0',
      boxSizing: 'border-box',
      cursor: isClickable ? 'pointer' : 'auto',
      display: 'flex',
      position: 'relative',
      transition: 'background-color 150ms ease',
      userSelect: 'none'
    }, isSection ? _objectSpread(_objectSpread({
      backgroundColor: theme.palette.background.default,
      borderColor: theme.palette.background.default,
      color: theme.palette.foreground.light
    }, typography(theme).captionSmall), {}, {
      padding: "6px ".concat(calcPadding(theme.layout.size3)),
      '& + li': _objectSpread({
        borderColor: theme.palette.background.default
      }, isHc && {
        border: 0
      })
    }) : _objectSpread(_objectSpread({
      color: theme.palette.foreground.default,
      padding: "".concat(theme.layout.size3, " ").concat(calcPadding(theme.layout.size3))
    }, typography(theme).label), {}, {
      '&:hover': {
        backgroundColor: theme.palette.neutral.backgroundLight,
        '> button': {
          opacity: 1
        }
      },
      '&:active': {
        backgroundColor: theme.palette.neutral.background,
        '> button': {
          opacity: 1
        }
      },
      '&::before': _objectSpread(_objectSpread({
        border: "2px solid ".concat(theme.palette.primary.default),
        borderRadius: theme.borderRadius4,
        content: "' '",
        opacity: 0,
        transition: 'all 50ms'
      }, position('absolute', 0)), isFocused && {
        borderRadius: "calc(".concat(theme.borderRadius4, " + 2px)"),
        opacity: 1
      })
    })), isHc && _objectSpread(_objectSpread({}, isSection && {
      borderBottom: "1px solid ".concat(theme.palette.stroke.default),
      borderTop: "1px solid ".concat(theme.palette.stroke.default)
    }), !isSection && {
      '&:hover': {
        backgroundColor: theme.palette.primary.hover,
        '> button': {
          backgroundColor: theme.palette.background.container,
          opacity: 1
        }
      },
      '&:active': {
        backgroundColor: theme.palette.primary.active,
        '> button': {
          backgroundColor: theme.palette.background.container,
          opacity: 1
        }
      }
    })), highContrastMediaQuery(theme)),
    center: _objectSpread({
      display: 'inline-flex',
      flex: '1',
      flexDirection: 'column',
      paddingLeft: theme.layout.size3,
      wordBreak: 'break-word'
    }, typography(theme).label),
    content: _objectSpread(_objectSpread({
      color: theme.palette.foreground.medium
    }, typography(theme).caption), {}, {
      '&:not(:last-of-type)': {
        marginBottom: theme.layout.size2
      }
    }),
    date: _objectSpread(_objectSpread({
      color: theme.palette.foreground.light
    }, typography(theme).labelSmall), {}, {
      '&:not(:last-of-type)': {
        marginBottom: theme.orbitalThree
      }
    }),
    leftSection: {
      display: 'inline-flex',
      width: iconSize
    },
    icon: {
      alignItems: 'center',
      backgroundColor: getStatusColor(true),
      borderRadius: '100%',
      boxSizing: 'border-box',
      color: getStatusColor(false),
      display: 'inline-flex',
      height: iconSize,
      justifyContent: 'center',
      width: iconSize,
      '> svg': {
        color: 'inherit'
      }
    },
    actionButton: {
      alignSelf: 'center',
      backgroundColor: theme.palette.background.container,
      opacity: open ? 1 : 0,
      transition: 'opacity 150ms ease',
      position: 'absolute',
      right: "calc(".concat(theme.layout.size3, " + 2px)"),
      ':focus': {
        backgroundColor: theme.palette.background.container,
        opacity: 1
      }
    },
    unreadCircle: {
      alignSelf: 'center',
      backgroundColor: theme.palette.negative.default,
      borderRadius: '50%',
      borderStyle: 'none',
      height: unreadCircleSize,
      margin: "0 calc(".concat(theme.layout.size3, " + 2px)"),
      width: unreadCircleSize,
      transition: 'opacity 150ms ease',
      opacity: showNotification ? 1 : 0
    }
  };
};
export default useStyles;